import type { SxProps, Theme } from '@mui/material/styles';
import SvgIcon from '@mui/material/SvgIcon';

type Props = {
	sx?: SxProps<Theme>;
};

export const RemoveItemIcon = ({ sx }: Props) => {
	return (
		<SvgIcon width='15' height='15' viewBox='0 0 10 15' fill='none' sx={sx}>
			<svg
				width='15'
				height='15'
				viewBox='0 0 15 15'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path
					d='M3.75 6.75V8.25H11.25V6.75H3.75ZM7.5 0C3.36 0 0 3.36 0 7.5C0 11.64 3.36 15 7.5 15C11.64 15 15 11.64 15 7.5C15 3.36 11.64 0 7.5 0ZM7.5 13.5C4.1925 13.5 1.5 10.8075 1.5 7.5C1.5 4.1925 4.1925 1.5 7.5 1.5C10.8075 1.5 13.5 4.1925 13.5 7.5C13.5 10.8075 10.8075 13.5 7.5 13.5Z'
					fill='currentColor'
				/>
			</svg>
		</SvgIcon>
	);
};
